<template>
  <div
    class="d-inline-block"
    @mouseover="mouseEnter"
    @mouseleave="mouseLeave"
    :style="`${wrapperStyle}`"
  >
    <lottie-vue-player
      :ref="refName"
      :src="src || 'static/assets/lottie/book.json'"
      :autoplay="autoplay"
      :loop="localLoop"
      :speed="speed || 1.5"
      :player-controls="playerControls"
      :style="`height: ${height || 100}px;${
        customStyle || 'background: #00000000'
      }`"
    ></lottie-vue-player>
  </div>
</template>

<script>
export default {
  name: "NurseryFeLottieLoading",

  props: {
    src: {
      type: String,
      default: "static/assets/lottie/book.json",
    },
    speed: {
      type: Number,
      default: 1.5,
    },
    height: {
      type: Number,
      default: 100,
    },
    customStyle: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    playerControls: {
      type: Boolean,
      default: false,
    },
    wrapperStyle: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      refName: null,
      localLoop: this.loop,
    };
  },

  beforeMount() {
    this.refName = this.$_sys.generateRandomString(10);
  },

  mounted() {},

  methods: {
    mouseEnter: async function () {
      await this.$refs[this.refName].toggleLoop();
    },
    mouseLeave: async function () {
      await this.$refs[this.refName].toggleLoop();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/base/component/lottie-loading.vue